/* eslint-disable no-unused-vars */
import axios from 'axios';
import moment from 'moment';
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/records/filings`;

const state = {
    filings: []
};

const getters = {
    allRecordFilings: state => state.filings
};

const actions = {
    async fetchRecordFilings({ commit }) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(url, {
                headers: { 'x-drmms-token': authToken }
            });
            let filings = [];
            filings = response.data.map((filing) => ({
                ...filing,
                date: moment(filing.createdAt).format('LLL'),
            }))
            commit('setRecordFilings', filings);
        } catch (err) {
            console.log(err);
        }
    },
    async createRecordFiling({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(url, body, {
                headers: { 'x-drmms-token': authToken }
            });
            const newFiling = Object.assign(response.data, { date: moment(response.data.createdAt).format('LLL') });
            commit('newRecordFiling', newFiling);
            return true;
        } catch (err) {
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 400) return { error: true, status: 500, message: 'Internal Server Error' };
            }
            console.log(err);
        }
    },
    async deleteRecordFiling({ commit }, id) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.delete(`${url}/${id}`, {
                headers: { 'x-drmms-token': authToken }
            });
            commit('removeRecordFiling', id);
        } catch (err) {
            console.log(err)
        }
    },
    async updateRecordFiling({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
                method: 'put',
                url: `${url}/${body.id}`,
                headers: { 'x-drmms-token': authToken },
                data: {
                    name: body.name,
                    title: body.title,
                    description: body.description,
                    security_level: body.security_level
                }
            });
            commit('updateRecordFilings', body);
            return true;
        } catch (err) {
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
            console.log(err);
        }
    }
};

const mutations = {
    setRecordFilings: (state, filings) => (state.filings = filings),
    newRecordFiling: (state, filing) => state.filings.push(filing),
    removeRecordFiling: (state, id) => state.filings = state.filings.filter(filter => filter.id !== id),
    updateRecordFilings: (state, updFiling) => {
        const index = state.filings.findIndex(filing => filing.id === updFiling.id);
        if (index !== -1) {
            state.filings.splice(index, 1, updFiling);
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}